import listSaga from './listSaga'
import staticEnumsSagas from './staticEnumsSaga'
import createRfq from './createRfq'
import oneRfqSaga from './oneRfqSaga'
import editSaga from './editSaga'
import inviteSuppliers from './inviteSuppliers'
import decline from './declineSaga'
import close from './closeSaga'
import outgoingDetail from './outgoingDetail'
import orderSaga from './orderSaga'
import companiesSearchSaga from './companiesSearchSaga'
import createOrderSaga from './createOrder'
import contactCompanyProfileSaga from './contactCompanyProfileSaga'

const eventsSagas = [
    listSaga(),
    staticEnumsSagas(),
    oneRfqSaga(),
    createRfq(),
    inviteSuppliers(),
    decline(),
    close(),
    outgoingDetail(),
    editSaga(),
    orderSaga(),
    companiesSearchSaga(),
    createOrderSaga(),
    contactCompanyProfileSaga()
]

export default eventsSagas
